import { createTheme, Theme } from '@mui/material'

// ─── MUI module augmentation ────────────────────────────────────────────────
declare module '@mui/material/styles' {
  interface TypeBackground {
    mainCenter: string;
    mainGradient: string;
    navMenu: string;
    dropdownMenu: string;
    panel: string;
    tooltip: string;
    accordionHeader: string;
    panelHeader: string;
    panelCenter: string;
    panelGradient: string;
  }

  interface TypeText {
    colorMain: string;
  }

  interface Palette {
    containerBox: {
      default: string;
      main: string;
    };
    dropdownBox: string;
    color: {
      icons: string;
    };
    cellHeader: string;
    Skeleton: {
      bg: string;
    };
    messageBox: string;
    boxShadow: string;
    disabled: string;
  }

  interface PaletteOptions {
    containerBox?: {
      default?: string;
      main?: string;
    };
    dropdownBox?: string;
    color?: {
      icons?: string;
    };
    cellHeader?: string;
    Skeleton?: {
      bg?: string;
    };
    messageBox?: string;
    boxShadow?: string;
    disabled?: string;
  }

  interface Theme {
    name?: string;
  }

  interface ThemeOptions {
    name?: string;
  }
}
// ────────────────────────────────────────────────────────────────────────────

// Light themes
export const lightBlueIndigo: Theme = createTheme({
	name: 'lightBlueIndigo',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#ebf6fd',
			mainGradient: 'linear-gradient(270deg, #215c97, #1976d2)',
			navMenu: '#1976d2',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#1976d2',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#1976d2',
			light: '#42a5f5',
			dark: '#1565c0',
			contrastText: '#fff'
		},
		secondary: {
			main: '#1976d2',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#ebf6fd',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#1976d2'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#1976d2'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightBlue: Theme = createTheme({
	name: 'lightBlue',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#e3f2fd',
			mainGradient: 'linear-gradient(270deg, #005cb2, #1e88e5)',
			navMenu: '#4fc354',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#1e88e5',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#1e88e5',
			light: '#6ab7ff',
			dark: '#005cb2',
			contrastText: '#fff'
		},
		secondary: {
			main: '#1e88e5',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#e3f2fd',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#1e88e5'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#1e88e5'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightRed: Theme = createTheme({
	name: 'lightRed',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#ffebee',
			mainGradient: 'linear-gradient(270deg, #b61827, #ef5350)',
			navMenu: '#f44336',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#ef5350',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#ef5350',
			light: '#ff867c',
			dark: '#b61827',
			contrastText: '#fff'
		},
		secondary: {
			main: '#ef5350',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#ffebee',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#ef5350'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#ef5350'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightGreen: Theme = createTheme({
	name: 'lightGreen',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#e8f5e9',
			mainGradient: 'linear-gradient(270deg, #087f23, #4caf50)',
			navMenu: '#4fc354',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#4caf50',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#4caf50',
			light: '#80e27e',
			dark: '#087f23',
			contrastText: '#fff'
		},
		secondary: {
			main: '#4caf50',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#e8f5e9',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#4caf50'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#4caf50'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightPink: Theme = createTheme({
	name: 'lightPink',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#fce4ec',
			mainGradient: 'linear-gradient(270deg, #b0003a, #e91e63)',
			navMenu: '#e91e63',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#e91e63',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#e91e63',
			light: '#ff6090',
			dark: '#b0003a',
			contrastText: '#fff'
		},
		secondary: {
			main: '#9c27b0',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#fce4ec',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#e91e63'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#e91e63'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightPurple: Theme = createTheme({
	name: 'lightPurple',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#f3e5f5',
			mainGradient: 'linear-gradient(270deg, #6a0080, #9c27b0)',
			navMenu: '#f8bbd0',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#9c27b0',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#9c27b0',
			light: '#d05ce3',
			dark: '#6a0080',
			contrastText: '#fff'
		},
		secondary: {
			main: '#9c27b0',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#f3e5f5',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#9c27b0'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#9c27b0'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightTeal: Theme = createTheme({
	name: 'lightTeal',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#e0f2f1',
			mainGradient: 'linear-gradient(270deg, #00675b, #009688)',
			navMenu: '#f8bbd0',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#009688',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#009688',
			light: '#52c7b8',
			dark: '#00675b',
			contrastText: '#fff'
		},
		secondary: {
			main: '#009688',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#e0f2f1',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#009688'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#009688'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightLime: Theme = createTheme({
	name: 'lightLime',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#f9fbe7',
			mainGradient: 'linear-gradient(270deg, #99aa00, #cddc39)',
			navMenu: '#f8bbd0',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#cddc39',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#cddc39',
			light: '#ffff6e',
			dark: '#99aa00',
			contrastText: '#fff'
		},
		secondary: {
			main: '#cddc39',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#f9fbe7',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#cddc39'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#cddc39'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightYellow: Theme = createTheme({
	name: 'lightYellow',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#fffde7',
			mainGradient: 'linear-gradient(270deg, #c8b900, #ffeb3b)',
			navMenu: '#f8bbd0',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#ffeb3b',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#ffeb3b',
			light: '#ffff72',
			dark: '#c8b900',
			contrastText: '#fff'
		},
		secondary: {
			main: '#ffeb3b',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#fffde7',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#ffeb3b'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#ffeb3b'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightAmber: Theme = createTheme({
	name: 'lightAmber',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#fff8e1',
			mainGradient: 'linear-gradient(270deg, #c68400, #ffb300)',
			navMenu: '#f8bbd0',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#ffb300',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#ffb300',
			light: '#ffe54c',
			dark: '#c68400',
			contrastText: '#fff'
		},
		secondary: {
			main: '#ffb300',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#fff8e1',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#ffb300'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#ffb300'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightOrange: Theme = createTheme({
	name: 'lightOrange',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#fff3e0',
			mainGradient: 'linear-gradient(270deg, #c66900, #ff9800)',
			navMenu: '#f8bbd0',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#ff9800',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#ff9800',
			light: '#ffc947',
			dark: '#c66900',
			contrastText: '#fff'
		},
		secondary: {
			main: '#ff9800',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#fff3e0',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#ff9800'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#ff9800'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightBrown: Theme = createTheme({
	name: 'lightBrown',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#efebe9',
			mainGradient: 'linear-gradient(270deg, #4b2c20, #795548)',
			navMenu: '#f8bbd0',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#795548',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#795548',
			light: '#a98274',
			dark: '#4b2c20',
			contrastText: '#fff'
		},
		secondary: {
			main: '#795548',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#efebe9',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#795548'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#795548'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const lightGray: Theme = createTheme({
	name: 'lightGray',
	palette: {
		mode: 'light',
		background: {
			default: '#ffffff',
			mainCenter: '#fafafa',
			mainGradient: 'linear-gradient(270deg, #707070, #9e9e9e)',
			navMenu: '#f8bbd0',
			dropdownMenu: '#f5f5f5',
			panel: '#ffffff',
			tooltip: '#9e9e9e',
			accordionHeader: '#F3F4F6',
			panelHeader: '#F3F4F6',
			panelCenter: '#ffffff',
			panelGradient: '#ffffff',
			paper: '#ffffff'
		},
		primary: {
			main: '#9e9e9e',
			light: '#cfcfcf',
			dark: '#707070',
			contrastText: '#fff'
		},
		secondary: {
			main: '#9e9e9e',
			light: '#ba68c8',
			dark: '#7b1fa2',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#d32f2f',
			light: '#ef5350',
			dark: '#c62828'
		},
		warning: {
			main: '#ed6c02',
			light: '#ff9800',
			dark: '#e65100'
		},
		info: {
			main: '#0288d1',
			light: '#03a9f4',
			dark: '#01579b'
		},
		success: {
			main: '#2e7d32',
			light: '#4caf50',
			dark: '#1b5e20'
		},
		containerBox: {
			default: '#ffffff',
			main: '#f5f5f5'
		},
		action: {
			active: 'rgba(0, 0, 0, 0.10)',
			hover: 'rgba(0, 0, 0, 0.05)',
			selected: '#fafafa',
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.87)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			disabled: 'rgba(0, 0, 0, 0.58)',
			colorMain: '#9e9e9e'
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		dropdownBox: '#ffffff',
		color: {
			icons: '#9e9e9e'
		},
		cellHeader: '#d3d3d3',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#d3e6fd',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

// Dark Themes
export const darkBlue: Theme = createTheme({
	name: 'darkBlue',
	palette: {
		mode: 'dark',
		primary: {
			main: '#1f5c8e',
			light: '#2196f3',
			dark: '#0d47a1',
			contrastText: '#fff'
		},
		secondary: {
			light: '#FFEA41',
			main: '#90caf9',
			dark: '#DBBE01',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#f44336',
			light: '#e57373',
			dark: '#d32f2f'
		},
		warning: {
			main: '#ffa726',
			light: '#ffb74d',
			dark: '#f57c00'
		},
		info: {
			main: '#29b6f6',
			light: '#4fc3f7',
			dark: '#0288d1'
		},
		success: {
			main: '#66bb6a',
			light: '#81c784',
			dark: '#388e3c'
		},
		background: {
			default: '#222B45',
			mainGradient: 'linear-gradient(270deg, #222B45, #222B45)',
			mainCenter: '#28324e',
			navMenu: '#222B45',
			panel: '#2d364e',
			dropdownMenu: '#484f65',
			tooltip: '#484f65',
			accordionHeader: '#2a3249e3',
			panelHeader: '#2a3249e3',
			panelCenter: '#484f65',
			panelGradient: '#384057',
			paper: '#2d364e'
		},
		containerBox: {
			default: '#2d354e',
			main: '#2d354e'
		},
		action: {
			active: 'rgba(255, 255, 255, 0.2)',
			hover: 'rgba(255, 255, 255, 0.08)',
			selected: 'rgba(255, 255, 255, 0.16)',
			disabled: 'rgba(255, 255, 255, 0.3)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: '#EEEEEF',
			secondary: '#AEB0B4',
			disabled: 'rgba(255, 255, 255, 0.5)',
			colorMain: '#EEEEEF'
		},
		divider: 'rgba(255, 255, 255, 0.12)',
		dropdownBox: '#2d354e',
		color: {
			icons: '#fff'
		},
		cellHeader: '#505050',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#1f5c8e',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

export const darkBlack: Theme = createTheme({
	name: 'darkBlack',
	palette: {
		mode: 'dark',
		background: {
			default: '#201f1e',
			mainGradient: 'linear-gradient(270deg, #201f1e, #201f1e)',
			mainCenter: '#252423',
			navMenu: '#201f1e',
			panel: '#3B3A39',
			dropdownMenu: '#585858',
			tooltip: '#616161eb',
			accordionHeader: '#25242369',
			panelHeader: '#3b3a39ba',
			panelCenter: '#585858',
			panelGradient: '#454443',
			paper: '#3B3A39'
		},
		primary: {
			main: '#1976d2',
			light: '#2196f3',
			dark: '#42a5f5',
			contrastText: '#fff'
		},
		secondary: {
			light: '#FFEA41',
			main: '#90caf9',
			dark: '#DBBE01',
			contrastText: 'rgba(0, 0, 0, 0.87)'
		},
		error: {
			main: '#f44336',
			light: '#e57373',
			dark: '#d32f2f'
		},
		warning: {
			main: '#ffa726',
			light: '#ffb74d',
			dark: '#f57c00'
		},
		info: {
			main: '#29b6f6',
			light: '#4fc3f7',
			dark: '#0288d1'
		},
		success: {
			main: '#66bb6a',
			light: '#81c784',
			dark: '#388e3c'
		},
		containerBox: {
			main: '#ffffffb3',
			default: '#3B3A39'
		},
		action: {
			active: 'rgba(255, 255, 255, 0.2)',
			hover: 'rgba(255, 255, 255, 0.08)',
			selected: 'rgba(255, 255, 255, 0.16)',
			disabled: 'rgba(255, 255, 255, 0.3)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)'
		},
		text: {
			primary: '#EEEEEF',
			secondary: '#AEB0B4',
			disabled: 'rgba(255, 255, 255, 0.5)',
			colorMain: '#EEEEEF'
		},
		divider: 'rgba(255, 255, 255, 0.12)',
		dropdownBox: '#3B3A39',
		color: {
			icons: '#fff'
		},
		cellHeader: '#505050',
		Skeleton: {
			bg: '#f5f5f5'
		},
		messageBox: '#1f5c8e',
		boxShadow: 'rgba(0, 0, 0, 0.1)',
		disabled: 'rgba(0, 0, 0, 0.26)'
	}
})

